'use strict';

var _regeneratorRuntime = require("/opt/build/repo/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _awaitAsyncGenerator = require("/opt/build/repo/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/opt/build/repo/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var varint = require('varint');

var cid = require('multiformats/cid');

var Digest = require('multiformats/hashes/digest');

var dagCbor = require('@ipld/dag-cbor');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n["default"] = e;
  return Object.freeze(n);
}

var varint__default = /*#__PURE__*/_interopDefaultLegacy(varint);

var Digest__namespace = /*#__PURE__*/_interopNamespace(Digest);

var CIDV0_BYTES = {
  SHA2_256: 18,
  LENGTH: 32,
  DAG_PB: 112
};

function readVarint(_x) {
  return _readVarint.apply(this, arguments);
}

function _readVarint() {
  _readVarint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(reader) {
    var bytes, i;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return reader.upTo(8);

          case 2:
            bytes = _context9.sent;
            i = varint__default["default"].decode(bytes);
            reader.seek(varint__default["default"].decode.bytes);
            return _context9.abrupt("return", i);

          case 6:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _readVarint.apply(this, arguments);
}

function readHeader(_x2) {
  return _readHeader.apply(this, arguments);
}

function _readHeader() {
  _readHeader = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(reader) {
    var length, header, block;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return readVarint(reader);

          case 2:
            length = _context10.sent;

            if (!(length === 0)) {
              _context10.next = 5;
              break;
            }

            throw new Error('Invalid CAR header (zero length)');

          case 5:
            _context10.next = 7;
            return reader.exactly(length);

          case 7:
            header = _context10.sent;
            reader.seek(length);
            block = dagCbor.decode(header);

            if (!(block == null || Array.isArray(block) || typeof block !== 'object')) {
              _context10.next = 12;
              break;
            }

            throw new Error('Invalid CAR header format');

          case 12:
            if (!(block.version !== 1)) {
              _context10.next = 16;
              break;
            }

            if (!(typeof block.version === 'string')) {
              _context10.next = 15;
              break;
            }

            throw new Error("Invalid CAR version: \"".concat(block.version, "\""));

          case 15:
            throw new Error("Invalid CAR version: ".concat(block.version));

          case 16:
            if (Array.isArray(block.roots)) {
              _context10.next = 18;
              break;
            }

            throw new Error('Invalid CAR header format');

          case 18:
            if (!Object.keys(block).filter(function (p) {
              return p !== 'roots' && p !== 'version';
            }).length) {
              _context10.next = 20;
              break;
            }

            throw new Error('Invalid CAR header format');

          case 20:
            return _context10.abrupt("return", block);

          case 21:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _readHeader.apply(this, arguments);
}

function readMultihash(_x3) {
  return _readMultihash.apply(this, arguments);
}

function _readMultihash() {
  _readMultihash = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(reader) {
    var bytes, codeLength, length, lengthLength, mhLength, multihash;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.next = 2;
            return reader.upTo(8);

          case 2:
            bytes = _context11.sent;
            varint__default["default"].decode(bytes);
            codeLength = varint__default["default"].decode.bytes;
            length = varint__default["default"].decode(bytes.subarray(varint__default["default"].decode.bytes));
            lengthLength = varint__default["default"].decode.bytes;
            mhLength = codeLength + lengthLength + length;
            _context11.next = 10;
            return reader.exactly(mhLength);

          case 10:
            multihash = _context11.sent;
            reader.seek(mhLength);
            return _context11.abrupt("return", multihash);

          case 13:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _readMultihash.apply(this, arguments);
}

function readCid(_x4) {
  return _readCid.apply(this, arguments);
}

function _readCid() {
  _readCid = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(reader) {
    var first, _bytes, _multihash, version, codec, bytes, multihash;

    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.next = 2;
            return reader.exactly(2);

          case 2:
            first = _context12.sent;

            if (!(first[0] === CIDV0_BYTES.SHA2_256 && first[1] === CIDV0_BYTES.LENGTH)) {
              _context12.next = 10;
              break;
            }

            _context12.next = 6;
            return reader.exactly(34);

          case 6:
            _bytes = _context12.sent;
            reader.seek(34);
            _multihash = Digest__namespace.decode(_bytes);
            return _context12.abrupt("return", cid.CID.create(0, CIDV0_BYTES.DAG_PB, _multihash));

          case 10:
            _context12.next = 12;
            return readVarint(reader);

          case 12:
            version = _context12.sent;

            if (!(version !== 1)) {
              _context12.next = 15;
              break;
            }

            throw new Error("Unexpected CID version (".concat(version, ")"));

          case 15:
            _context12.next = 17;
            return readVarint(reader);

          case 17:
            codec = _context12.sent;
            _context12.next = 20;
            return readMultihash(reader);

          case 20:
            bytes = _context12.sent;
            multihash = Digest__namespace.decode(bytes);
            return _context12.abrupt("return", cid.CID.create(version, codec, multihash));

          case 23:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
  return _readCid.apply(this, arguments);
}

function readBlockHead(_x5) {
  return _readBlockHead.apply(this, arguments);
}

function _readBlockHead() {
  _readBlockHead = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(reader) {
    var start, length, cid, blockLength;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            start = reader.pos;
            _context13.next = 3;
            return readVarint(reader);

          case 3:
            length = _context13.sent;

            if (!(length === 0)) {
              _context13.next = 6;
              break;
            }

            throw new Error('Invalid CAR section (zero length)');

          case 6:
            length += reader.pos - start;
            _context13.next = 9;
            return readCid(reader);

          case 9:
            cid = _context13.sent;
            blockLength = length - (reader.pos - start);
            return _context13.abrupt("return", {
              cid: cid,
              length: length,
              blockLength: blockLength
            });

          case 12:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
  return _readBlockHead.apply(this, arguments);
}

function readBlock(_x6) {
  return _readBlock.apply(this, arguments);
}

function _readBlock() {
  _readBlock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(reader) {
    var _yield$readBlockHead, cid, blockLength, bytes;

    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            _context14.next = 2;
            return readBlockHead(reader);

          case 2:
            _yield$readBlockHead = _context14.sent;
            cid = _yield$readBlockHead.cid;
            blockLength = _yield$readBlockHead.blockLength;
            _context14.next = 7;
            return reader.exactly(blockLength);

          case 7:
            bytes = _context14.sent;
            reader.seek(blockLength);
            return _context14.abrupt("return", {
              bytes: bytes,
              cid: cid
            });

          case 10:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));
  return _readBlock.apply(this, arguments);
}

function readBlockIndex(_x7) {
  return _readBlockIndex.apply(this, arguments);
}

function _readBlockIndex() {
  _readBlockIndex = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(reader) {
    var offset, _yield$readBlockHead2, cid, length, blockLength, index;

    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            offset = reader.pos;
            _context15.next = 3;
            return readBlockHead(reader);

          case 3:
            _yield$readBlockHead2 = _context15.sent;
            cid = _yield$readBlockHead2.cid;
            length = _yield$readBlockHead2.length;
            blockLength = _yield$readBlockHead2.blockLength;
            index = {
              cid: cid,
              length: length,
              blockLength: blockLength,
              offset: offset,
              blockOffset: reader.pos
            };
            reader.seek(index.blockLength);
            return _context15.abrupt("return", index);

          case 10:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
  return _readBlockIndex.apply(this, arguments);
}

function createDecoder(reader) {
  var headerPromise = readHeader(reader);
  return {
    header: function header() {
      return headerPromise;
    },
    blocks: function blocks() {
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _awaitAsyncGenerator(headerPromise);

              case 2:
                _context.next = 4;
                return _awaitAsyncGenerator(reader.upTo(8));

              case 4:
                _context.t0 = _context.sent.length;

                if (!(_context.t0 > 0)) {
                  _context.next = 10;
                  break;
                }

                _context.next = 8;
                return readBlock(reader);

              case 8:
                _context.next = 2;
                break;

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    blocksIndex: function blocksIndex() {
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _awaitAsyncGenerator(headerPromise);

              case 2:
                _context2.next = 4;
                return _awaitAsyncGenerator(reader.upTo(8));

              case 4:
                _context2.t0 = _context2.sent.length;

                if (!(_context2.t0 > 0)) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 8;
                return readBlockIndex(reader);

              case 8:
                _context2.next = 2;
                break;

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  };
}

function bytesReader(bytes) {
  var pos = 0;
  return {
    upTo: function upTo(length) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", bytes.subarray(pos, pos + Math.min(length, bytes.length - pos)));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    exactly: function exactly(length) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(length > bytes.length - pos)) {
                  _context4.next = 2;
                  break;
                }

                throw new Error('Unexpected end of data');

              case 2:
                return _context4.abrupt("return", bytes.subarray(pos, pos + length));

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    seek: function seek(length) {
      pos += length;
    },

    get pos() {
      return pos;
    }

  };
}

function chunkReader(readChunk) {
  var pos = 0;
  var have = 0;
  var offset = 0;
  var currentChunk = new Uint8Array(0);

  var read = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(length) {
      var bufa, chunk, off, _i, _bufa, b;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              have = currentChunk.length - offset;
              bufa = [currentChunk.subarray(offset)];

            case 2:
              if (!(have < length)) {
                _context5.next = 12;
                break;
              }

              _context5.next = 5;
              return readChunk();

            case 5:
              chunk = _context5.sent;

              if (!(chunk == null)) {
                _context5.next = 8;
                break;
              }

              return _context5.abrupt("break", 12);

            case 8:
              if (have < 0) {
                if (chunk.length > have) {
                  bufa.push(chunk.subarray(-have));
                }
              } else {
                bufa.push(chunk);
              }

              have += chunk.length;
              _context5.next = 2;
              break;

            case 12:
              currentChunk = new Uint8Array(bufa.reduce(function (p, c) {
                return p + c.length;
              }, 0));
              off = 0;

              for (_i = 0, _bufa = bufa; _i < _bufa.length; _i++) {
                b = _bufa[_i];
                currentChunk.set(b, off);
                off += b.length;
              }

              offset = 0;

            case 16:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function read(_x8) {
      return _ref.apply(this, arguments);
    };
  }();

  return {
    upTo: function upTo(length) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(currentChunk.length - offset < length)) {
                  _context6.next = 3;
                  break;
                }

                _context6.next = 3;
                return read(length);

              case 3:
                return _context6.abrupt("return", currentChunk.subarray(offset, offset + Math.min(currentChunk.length - offset, length)));

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    exactly: function exactly(length) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(currentChunk.length - offset < length)) {
                  _context7.next = 3;
                  break;
                }

                _context7.next = 3;
                return read(length);

              case 3:
                if (!(currentChunk.length - offset < length)) {
                  _context7.next = 5;
                  break;
                }

                throw new Error('Unexpected end of data');

              case 5:
                return _context7.abrupt("return", currentChunk.subarray(offset, offset + length));

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    seek: function seek(length) {
      pos += length;
      offset += length;
    },

    get pos() {
      return pos;
    }

  };
}

function asyncIterableReader(asyncIterable) {
  var iterator = asyncIterable[Symbol.asyncIterator]();

  function readChunk() {
    return _readChunk.apply(this, arguments);
  }

  function _readChunk() {
    _readChunk = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      var next;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return iterator.next();

            case 2:
              next = _context8.sent;

              if (!next.done) {
                _context8.next = 5;
                break;
              }

              return _context8.abrupt("return", null);

            case 5:
              return _context8.abrupt("return", next.value);

            case 6:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));
    return _readChunk.apply(this, arguments);
  }

  return chunkReader(readChunk);
}

exports.asyncIterableReader = asyncIterableReader;
exports.bytesReader = bytesReader;
exports.chunkReader = chunkReader;
exports.createDecoder = createDecoder;
exports.readHeader = readHeader;